import React, { useEffect, useState } from 'react';
import { Link, useParams, Navigate } from 'react-router-dom';
import { marked } from 'marked';
import Background from '../components/Background';
import Navbar from '../components/Navbar';
import post1 from '../posts/hello-world';

const ALL_POSTS = { [post1.slug]: post1 };

function formatDate(iso) {
  return new Date(iso).toLocaleDateString('en-US', {
    year: 'numeric', month: 'long', day: 'numeric',
  });
}

export default function BlogPostPage() {
  const { slug } = useParams();
  const post = ALL_POSTS[slug];

  const [html, setHtml] = useState('');

  useEffect(() => {
    if (post) {
      setHtml(marked.parse(post.content));
    }
  }, [post]);

  if (!post) return <Navigate to="/blog" replace />;

  return (
    <div style={{ minHeight: '100vh', position: 'relative' }}>
      <Background />

      <article style={{
        position: 'relative', zIndex: 1,
        maxWidth: '700px',
        margin:   '0 auto',
        padding:  'clamp(4rem, 10vh, 8rem) 1.5rem 6rem',
      }}>
        <Link to="/blog" style={{
          display:        'inline-block',
          fontFamily:     'var(--font-body)',
          fontSize:       '0.875rem',
          color:          'var(--color-text-secondary)',
          textDecoration: 'none',
          marginBottom:   '3rem',
          letterSpacing:  '0.02em',
        }}>
          ← Blog
        </Link>

        <time style={{
          fontFamily:    'var(--font-body)',
          fontSize:      '0.8125rem',
          color:         'var(--color-text-secondary)',
          letterSpacing: '0.04em',
          display:       'block',
          marginBottom:  '1rem',
        }}>
          {formatDate(post.date)}
        </time>

        <h1 style={{
          fontFamily:    'var(--font-display)',
          fontSize:      'clamp(1.75rem, 4vw, 2.5rem)',
          fontWeight:    400,
          color:         'var(--color-text-primary)',
          margin:        '0 0 3rem',
          lineHeight:    1.2,
          letterSpacing: '0.01em',
        }}>
          {post.title}
        </h1>

        <div
          className="prose"
          dangerouslySetInnerHTML={{ __html: html }}
        />
      </article>

      <Navbar />
    </div>
  );
}
